class MultiChoice extends HTMLElement {
  constructor() {
    super();

    this.touchPosition = {
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0
    }

    this.activeClasses = {
      itemEmpty: 'saved-colors__item--empty',
      openModal: 'modal-opened',
      choosedItem: 'choosed-item__active',
      actions: 'choice-area__actions--one',
      selecting: 'selecting'
    };

    this.metaobjectData = JSON.parse(this.querySelector('[data-multi="json"]').textContent);

    const sliderComponent = this.querySelector('slider-component');

    this.bodyElement = document.querySelector('body');
    this.elements = {
      colorsWrap: this.querySelectorAll('[data-multi="colors-wrap"]'),
      selectedItems: this.querySelectorAll('[data-multi="selected-item"]'),
      selectedTitle: this.querySelector('[data-multi="selected-title"]'),
      btnSelect: this.querySelector('[data-multi="btn-select"]'),
      addToCart: this.querySelector('[data-multi="add-to-cart"]'),
      modal: this.querySelector('[data-multi="modal"]'),
      modalContent: this.querySelector('[data-multi="modal-content"]'),
      modalClose: this.querySelector('[data-multi="modal-close"]'),
      modalSwipeClose: this.querySelector('[data-multi="modal-swipe-close"]'),
      slideComponent: sliderComponent,
      sliderCounterCurrent: sliderComponent.querySelector('.slider-counter--current'),
      sliderCounterTotal: sliderComponent.querySelector('.slider-counter--total'),
      slideList: sliderComponent.querySelector('#Slider-multi'),
    };

    this.currentProduct = this.metaobjectData.currentProduct;
    this.locale = this.metaobjectData.locales;

    if (this.metaobjectData.productSwatch) {
      this.currentProduct.swatch_url = this.metaobjectData.productSwatch;
    }

    if (this.metaobjectData?.discounts) {
      this.discounts = [0, ...this.metaobjectData?.discounts];
    }

    this.state = {
      arrSelectedProduct: [this.currentProduct, 0, 0, 0, 0],
      selectedProduct: null,
      index: null
    };

    this.init();
  }

  connectedCallback() {}

  disconnectedCallback() {}

  init() {
    this.addEventListener('click', this.clickHandler.bind(this));
    this.swipeToCLoseModal();
    this.selectFirstProductActiveTab();
  }

  clickHandler(event) {
    const target = event.target;
    const isModalOpened = this.bodyElement.classList.contains(this.activeClasses.openModal);

    // Close modal
    if (isModalOpened && (target === this.elements.modal || target === this.elements.modalClose)) {
      this.closeModal();
    }

    // Open modal
    if (!isModalOpened && target.dataset.multi === 'selected-item') {
      this.openModal();
    }

    // Choose item
    if (isModalOpened && target.dataset.multi === 'choosed-item') {
      this.handleChooseItem(target);
    }

    // Select item
    if (isModalOpened && target === this.elements.btnSelect) {
     this.handleBtnSelect();
    }

    // Add to cart
    if (isModalOpened && target.dataset.multi === 'add-to-cart') {
      this.handleAddToCart();
    }

    // Remove Item
    if (isModalOpened && target.dataset.multi === 'remove') {
      this.handleRemoveChooseItem(target);
    }
  }

  // State start
  deleteFromState(index) {
    // delete from the list of selected products
    if (!index) return;

    this.state.arrSelectedProduct[index] = 0;

    this.showHideButton();
  }

  addSelectedProduct() {
    this.state.index = this.getIndex;

    if (this.state.index === -1) return;

    this.state.arrSelectedProduct[this.state.index] = this.state.selectedProduct;
    // on click on a product, clear the state (selectedProduct),
    // select it: add an active class and push to the state
  }

  get getIndex() {
    return this.state.arrSelectedProduct.findIndex(el => el === 0);
  }

  selectProduct(target) {
    const productData = JSON.parse(target.querySelector('[data-multi="media-json"]').textContent);
    if (!productData?.available) return true;
    const prevSelectedItems = this.querySelectorAll(`.${this.activeClasses.choosedItem}`);

    if (prevSelectedItems.length) {
      prevSelectedItems.forEach(elem => elem.classList.remove(this.activeClasses.choosedItem));
    }

    this.state.selectedProduct = productData;

    if (target.dataset.swatch) {
      this.state.selectedProduct.swatch_url = target.dataset.swatch;
    }

    const index = this.getIndex;
    this.updateSelectingClass(index);
  }

  sortStateSelectedProducts() {
    this.state.arrSelectedProduct.sort((a, b) => (typeof b === 'object') - (typeof a === 'object'));
  }
  // State END

  creatHtml() {
    return this.state.arrSelectedProduct.map(this.renderItem.bind(this)).join('');
  }

  creatEmptyItemHtml(_, index) {
    const text = this.locale;
    /*const oldBadge = `<span class="badge badge--colors-empty badge--sm fw-7">${text.add_save}</span>`;*/
    const badge = this.discounts[index] !== '0' ? `<span class="badge badge--colors-save badge--sm fw-7">${text.save} ${this.discounts[index]}</span>` : '';

    return `
      <li class="saved-colors__item saved-colors__item--empty" data-multi-index="${index}" data-multi="selected-item">
        <div class="saved-colors__media media">
          <svg class="icon multi-plus media__cancel"><use href="#multi-plus"></use></svg>
        </div>
        <div class="saved-colors__title center fw-7" data-label="${text.selecting}"><span>${text.select}</span></div>
        ${badge}
      </li>
    `;
  }

  creatProductItemHtml(product, index) {
    const text = this.locale;
    const {images, price, title} = product;
    const convertedPrice = `
    <span class="price price--small">
      <span class="price__container">
        <span class="price__regular">
          <span class="price-item price-item--regular">${window.bfTheme.formattingPrice(price)}</span>
        </span>
      </span>
    </span>
    `;

    const status = index === 0 ? text.default : text.selected;
    const dataAttr = index === 0 ? '' : `data-multi-index="${index}" data-multi="selected-item"`;
    const badge = this.discounts[index] && this.discounts[index] !== '0' && index !== 0
      ? `<div class="badge badge--colors-saving badge--sm fw-7">
          ${text.saving} ${this.discounts[index]}
        </div>`
      : '';

    const removeButton = index === 0 ? '' : `
      <button class="saved-colors__button-remove media__cancel" data-multi="remove">
        <svg class="icon multi-cross"><use href="#multi-cross"></use></svg>
      </button>
    `;
    const fallbackProductSwatch = (images && images.length > 1) ? images[1] : (images && images.length > 0 ? images[0] : '');
    const imgSrc = product.swatch_url ? product.swatch_url : `${fallbackProductSwatch}&width=480`;
    return `
    <li class="saved-colors__item" ${dataAttr}>
      <div class="saved-colors__media media">
        <svg class="icon multi-shape media__cancel"><use href="#multi-shape"></use></svg>
        <img src="${imgSrc}" alt="${title}">
        ${removeButton}
      </div>
      <div class="saved-colors__title center fw-7">${status}</div>
      ${badge}
    </li>
    `;
  }

  render() {
    this.elements.colorsWrap.forEach(elem => {
      elem.innerHTML = this.creatHtml();
    });
  }

  updateSelectingClass(index) {
    this.elements.colorsWrap.forEach(elem => {
      elem.querySelector(`[data-multi-index].${this.activeClasses.selecting}`)?.classList.remove(this.activeClasses.selecting);
      elem.querySelector(`[data-multi-index="${index}"]`)?.classList.add(this.activeClasses.selecting);
    });
  }

  renderItem(item, index) {
    if (item === 0) {
      return this.creatEmptyItemHtml(item, index)
    }

    return this.creatProductItemHtml(item, index);
  }

  resetElement() {
    this.state = {
      arrSelectedProduct: [this.currentProduct, 0, 0, 0, 0],
      selectedProduct: null,
      index: null
    };

    this.render();

    this.elements.selectedTitle.textContent =  this.locale.none;

    const selectedItems = this.querySelectorAll(`.${this.activeClasses.choosedItem}`);
    if (selectedItems.length) {
      selectedItems.forEach(elem => elem.classList.remove(this.activeClasses.choosedItem));
    }

    const buttonWrapper = this.querySelector(`.${this.activeClasses.actions}`);
    buttonWrapper?.classList.remove(this.activeClasses.actions);

    this.elements.btnSelect.disabled = true;
  }

  handleChooseItem(target) {
    if (this.selectProduct(target)) return;

    this.elements.selectedTitle.textContent = this.state.selectedProduct.title;

    target.classList.add(this.activeClasses.choosedItem);
    this.elements.btnSelect.disabled = false;
    this.updateSlider();
  }

  showHideButton() {
    const index = this.getIndex;
    if (index === -1 ) {
      this.elements.btnSelect.parentElement.classList.add(this.activeClasses.actions);
      return;
    }

    this.elements.btnSelect.parentElement.classList.remove(this.activeClasses.actions);
  }

  handleBtnSelect() {
    if (!this.state.selectedProduct) return;
    this.addSelectedProduct();
    const index = this.state.index;

    if (index === -1) {
      return;
    }

    this.render();
    this.updateSelectingClass(index + 1);
    this.showHideButton();
  }

  handleAddToCart() {
    this.closest('product-info').querySelector('[id^="ProductSubmitButton-"]').click();
    this.closeModal();
    this.resetElement();
  }

  handleRemoveChooseItem(target) {
    const selectedItem = target.closest('[data-multi="selected-item"]');
    const indexOfSelectedItem = Number(selectedItem.dataset.multiIndex);

    this.deleteFromState(indexOfSelectedItem);
    this.sortStateSelectedProducts();
    this.render();

    this.updateSelectingClass(this.getIndex);
  }

  // Slider Start
  slideTemplate(media, index) {
    const isFirst = index === 0;
    const biggestWidth = 990;
    const imgWidths = [246, 493, 600, 713, 823, biggestWidth];
    const imgSrcSets = imgWidths.map(w=> `${media.src}&width=${w} ${w}w`).join(', ')
    const activeClass = isFirst ? 'is-active' : '';
    const lazyType = isFirst ? 'eager' : 'lazy';
    const mediaRatio = (1 / media.aspect_ratio) * 100;

  return `
    <li id="Slide-multi-${ media.id }" class="grid__item slider__slide ${activeClass}" data-media-id="multi-${ media.id }">
      <div class="media media--transparent" style="padding-bottom: ${mediaRatio}%;">
        <img
          src="${media.src}&width=${biggestWidth}"
          srcset="${imgSrcSets}"
          width="${biggestWidth}"
          loading="${lazyType}"
          alt=""
        >
      </div>
    </li>
    `;
  }
  updateSlider() {
    const {media} =  this.state.selectedProduct;
    const filteredMedia = media.filter(m => m.media_type === 'image');
    if (!filteredMedia.length) return;

    const slidesHtml = filteredMedia.map(this.slideTemplate.bind(this)).join('');

    this.elements.sliderCounterCurrent.textContent = '1';
    this.elements.sliderCounterTotal.textContent = filteredMedia.length;
    this.elements.slideList.innerHTML = slidesHtml;

    this.elements.slideComponent.resetPages()
    this.elements.slideComponent.querySelector('.slider-counter__link').click();
  }
  // Slider END

  // Tabs Start
  selectFirstProductActiveTab() {
    document.addEventListener('tab:updated', (event) => {
      if (!event?.detail?.tabsContent) return;

      event.detail.tabsContent.querySelector('[data-multi="choosed-item"]').click();
    });
  }
  // Tabs END

  // Modal Start
  swipeToCLoseModal() {
    const swipedElement = this.elements.modalSwipeClose;

    swipedElement.addEventListener('touchstart', (event) => {
      const {screenX, screenY} = event.changedTouches[0];

      this.touchPosition.startX = screenX;
      this.touchPosition.startY = screenY;
    }, false);

    swipedElement.addEventListener('touchend', (event) => {
      const {screenX, screenY} = event.changedTouches[0];

      this.touchPosition.endX = screenX;
      this.touchPosition.endY = screenY;

      const swipePosition = window.bfTheme.handleGesture(this.touchPosition);

      if ( swipePosition === 'down') {
        this.closeModal();
      }
    }, false);
  }

  openModal = () => {
    this.bodyElement.classList.add(this.activeClasses.openModal);
  };

  closeModal() {
    this.bodyElement.classList.remove(this.activeClasses.openModal);
  }
  // Modal END
}

customElements.define('multi-choice', MultiChoice);
